import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import miloCookie from '../../common/cookie';
import loginStatus from '../../common/loginStatus';
import miloEvent from '../../common/event';
import Request from '../../common/network';
import loader from '../../common/loader';
import ATM from '../../util/atm';
import { extend, isFunction, isArray, g } from '../../common/base';
export var getGameId = function getGameId(s_url) {
  var url = s_url || window.location.host;
  var gameId = url.replace(/(\w+?)\.qq\.com/gi, '$1');
  return gameId == url ? '' : gameId;
}; // frame管理

export var frameManager = {
  // 存储未执行的callback
  arrCallbacks: [],
  // 执行callback，解决并行callbck问题
  doCallback: function doCallback(service) {
    var self = this;

    for (var i = 0; i < self.arrCallbacks.length;) {
      var cbObj = self.arrCallbacks[i];

      if (service == cbObj.service) {
        var childWin = document.getElementById("loginmanager_".concat(cbObj.service)).contentWindow || null;

        if (isFunction(cbObj.cb)) {
          cbObj.cb(childWin);
        }

        self.arrCallbacks.splice(i, 1);
      } else {
        i = i + 1;
        continue;
      }
    }
  },
  // iframe进度队列
  waitingQueue: {},
  // 初始化iFrame
  open: function open(service, url, callback) {
    var self = this;
    self.arrCallbacks.push({
      cb: callback,
      service: service
    });

    if (2 == self.waitingQueue[service]) {
      // 已完成
      self.doCallback(service);
      return;
    }

    if (1 == self.waitingQueue[service]) {
      return;
    }

    self.waitingQueue[service] = 1; // 1:waiting  2:done
    // 等body的 DOM ready之后再进行下面操作，否则可能会无法访问

    miloEvent.ready(function () {
      var iframe = document.createElement('iframe');
      iframe.src = url;
      iframe.id = "loginmanager_".concat(service);
      iframe.width = 0;
      iframe.height = 0;
      iframe.frameborder = 0;
      iframe.style.border = '0';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      if (iframe.attachEvent) {
        iframe.attachEvent('onload', function () {
          self.waitingQueue[service] = 2;
          self.doCallback(service);
        });
      } else {
        iframe.onload = function () {
          self.waitingQueue[service] = 2;
          self.doCallback(service);
        };
      }
    });
  }
}; // 登录相关的接口信息

export var getLoginInterFace = function getLoginInterFace() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = opt.type,
      acctype = opt.acctype,
      uin = opt.uin;

  if ('checkLogin' == type) {
    return "".concat(location.protocol, "//ams.game.qq.com/ams/userLoginSvr");
  }

  if ('userinfo' == type) {
    if ('wx' == acctype) {
      return "".concat(location.protocol, "//apps.game.qq.com/ams/ame/getWXUser.php");
    }
  } else if ('avatar' == type) {
    if ('pt' == acctype) {
      var ptAppId = '21000501'; // pt默认appid,暂时未支持用户自定义，不传也可以取到头像

      var api = "http://ptlogin2.qq.com/getface?appid=".concat(ptAppId, "&imgtype=3&encrytype=0&devtype=0&keytpye=0&uin=").concat(uin);

      if (location.protocol == 'https:') {
        api = "https://ssl.ptlogin2.qq.com/getface?appid=".concat(ptAppId, "&imgtype=3&encrytype=0&devtype=0&keytpye=0&uin=").concat(uin);
      }

      return api;
    } //

  } else if ('codetoopenid' == type) {
    if ('wx' == acctype) {
      return "".concat(location.protocol, "//apps.game.qq.com/ams/ame/codeToOpenId.php");
    }
  }
}; // cookie设置相关

export var loginCookie = {
  // 设置本域名下会话cookie
  setSession: function setSession(oCookie) {
    for (var k in oCookie) {
      miloCookie.set(k, oCookie[k], 0, location.host, '/');
    }
  },
  // 设置本域名下的持久cookie,
  // iExpire为过期时间
  setLocal: function setLocal(oCookie, iExpire) {
    for (var k in oCookie) {
      miloCookie.set(k, oCookie[k], iExpire, location.host, '/');
    }
  },
  // 清本地域下的cookie
  clearLocal: function clearLocal() {
    var oCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['openid', 'appid', 'acctype', 'access_token', 'IED_LOG_INFO_NEW', 'refresh_token', 'ieg_ams_token_time', 'ieg_ams_session_token', 'ieg_ams_token', 'login_origin'];

    for (var i = 0; i < oCookie.length; i++) {
      miloCookie.clear(oCookie[i], location.host, '/');
    }
  },
  // 清qq域下的cookie
  clearQQ: function clearQQ() {
    var oCookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['uin', 'skey', 'appid', 'acctype', 'access_token', 'openid', 'refresh_token', 'IED_LOG_INFO2'];

    for (var i = 0; i < oCookie.length; i++) {
      miloCookie.clear(oCookie[i], 'qq.com', '/');
    }
  },
  setQQ: function setQQ(oCookie, iExpire) {
    for (var k in oCookie) {
      miloCookie.set(k, oCookie[k], iExpire, 'qq.com', '/');
    }
  },
  getAll: function getAll() {
    // wx,wg,qc
    var acctype = miloCookie.get('acctype');
    var appid = miloCookie.get('appid');
    var openid = miloCookie.get('openid');
    var access_token = miloCookie.get('access_token');
    var refresh_token = miloCookie.get('refresh_token'); // pt

    var uin = miloCookie.get('uin');
    var skey = miloCookie.get('skey');
    return {
      acctype: acctype,
      appid: appid,
      openid: openid,
      access_token: access_token,
      refresh_token: refresh_token,
      uin: uin,
      skey: skey
    };
  }
}; // 和game.qq.com进行登录态交互，从game.qq.com获取登录态，以及存储登录态到game.qq.com

export var proxyManager = {
  // 从game.qq.com获取存储的登录态

  /*
        约定规范：
        pt: {p_ksey,p_uin}
        wg: {appid,openid,access_token,refresh_token}
        qc: {appid,openid,access_token}
        wx: {appid,openid,access_token}
    */
  get: function get(iPrivateLogin) {
    // 如果需要登录态独立，则跳过
    return new Promise(function (resolve, reject) {
      if (iPrivateLogin) {
        resolve({
          isGet: false
        });
        return;
      }

      var callbackName = "getFromGame_".concat(Math.ceil(100000 * Math.random()));
      window["".concat(callbackName, "_resolved")] = false;

      window[callbackName] = function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        window["".concat(callbackName, "_resolved")] = true;
        var wx = data.wx,
            qc = data.qc,
            wg = data.wg,
            ks = data.ks;
        var oResult = {}; // 处理data

        if (wx && Array.isArray(wx) && wx.length > 2) {
          // 有微信登录态
          var _wx = _slicedToArray(wx, 3),
              appid = _wx[0],
              openid = _wx[1],
              access_token = _wx[2];

          oResult.wx = {
            appid: appid,
            openid: openid,
            access_token: access_token
          };
        }

        if (qc && Array.isArray(qc) && qc.length > 2) {
          // 有qc登录态
          var _qc = _slicedToArray(qc, 3),
              _appid = _qc[0],
              _openid = _qc[1],
              _access_token = _qc[2];

          oResult.qc = {
            appid: _appid,
            openid: _openid,
            access_token: _access_token
          };
        }

        if (wg && Array.isArray(wg) && wg.length > 3) {
          // 有wg登录态
          var _wg = _slicedToArray(wg, 4),
              _appid2 = _wg[0],
              _openid2 = _wg[1],
              _access_token2 = _wg[2],
              refresh_token = _wg[3];

          oResult.wg = {
            appid: _appid2,
            openid: _openid2,
            access_token: _access_token2,
            refresh_token: refresh_token || ''
          };
        }

        if (ks && Array.isArray(ks) && ks.length > 2) {
          // 有ks登录态
          var _ks = _slicedToArray(ks, 3),
              _appid3 = _ks[0],
              _openid3 = _ks[1],
              _access_token3 = _ks[2];

          oResult.ks = {
            appid: _appid3,
            openid: _openid3,
            access_token: _access_token3
          };
        }

        resolve({
          isGet: true,
          data: oResult
        });
      };

      if ('function' !== typeof window.postMessage) {
        // 不支持postMessage
        loginStatus.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function (childWin) {
          childWin.syncCookie({
            action: 'getProxyStatus'
          }, function (_ref) {
            var data = _ref.data;
            window["".concat(callbackName, "_resolved")] = true;
            resolve({
              isGet: true,
              data: data
            });
          });
        });
      } else {
        loginStatus.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function () {
          var iframe = g('loginStatusSyncFrame_ams_ame');
          iframe.contentWindow.postMessage(JSON.stringify({
            action: 'getProxyStatus',
            callbackName: callbackName
          }), '*');
        });
      }

      setTimeout(function () {
        if (!window["".concat(callbackName, "_resolved")]) {
          reject({
            erreCode: -999,
            errMsg: '网络请求超时'
          });
        }
      }, 10000);
    });
  },
  // 存储登录态到game.qq.com
  set: function set(acctype) {
    var oCookie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iPrivateLogin = arguments.length > 2 ? arguments[2] : undefined;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    // 如果需要登录态独立，则跳过
    if (iPrivateLogin) {
      isFunction(callback) && callback({
        isSet: false
      });
      return;
    }

    var callbackName = "storeToGame_".concat(Math.ceil(100000 * Math.random()));

    window[callbackName] = function () {
      isFunction(callback) && callback({
        isSet: true,
        sMsg: '存储登录态成功'
      });
    };

    if (!isLegalAcctype(acctype)) {
      isFunction(callback) && callback({
        isSet: false,
        sMsg: 'acctype非法'
      });
      return;
    }

    var appid = oCookie.appid,
        openid = oCookie.openid,
        access_token = oCookie.access_token,
        refresh_token = oCookie.refresh_token;

    if (!appid || !openid || !access_token) {
      isFunction(callback) && callback({
        isSet: false,
        sMsg: 'cookie传值缺失'
      });
      return;
    }

    var arrCookie = [acctype, appid, openid, access_token];

    if (refresh_token) {
      arrCookie.push(refresh_token);
    }

    if ('function' !== typeof window.postMessage) {
      // 不支持postMessage
      loginStatus.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function (childWin) {
        childWin.syncCookie({
          action: 'storeProxyStatus',
          cookieObj: arrCookie
        }, function () {
          isFunction(callback) && callback({
            isSet: true,
            sMsg: '存储登录态成功'
          });
        });
      });
    } else {
      loginStatus.init('ams_ame', "".concat(location.protocol, "//") + 'apps.game.qq.com/ams/asyncCookie.html', function () {
        var iframe = g('loginStatusSyncFrame_ams_ame');
        iframe.contentWindow.postMessage(JSON.stringify({
          action: 'storeProxyStatus',
          cookieObj: arrCookie,
          callbackName: callbackName
        }), '*');
      });
    }
  },
  // 清空登录态
  clear: function clear(iPrivateLogin, callback) {
    // 如果需要登录态独立，则跳过
    if (iPrivateLogin) {
      isFunction(callback) && callback();
      return;
    }

    loginStatus.clearAME(function () {
      isFunction(callback) && callback();
    }, ['iegams_milo_proxylogin_wx', 'iegams_milo_proxylogin_qc', 'iegams_milo_proxylogin_wg', 'iegams_milo_proxylogin_ks']);
  }
}; // 检查是否合法的acctype值

export var isLegalAcctype = function isLegalAcctype(acctype) {
  return (// 目前仅允许wegame，互联、微信、快手三种openid方式的登录态，如果不是再检测是否pt(uin+skey)
    /^(wg|qc|wx|ks)$/.test(acctype)
  );
}; // 调用loginSvr的缓存数据

export var loginSvrCache = {
  oCache: {},
  set: function set(id, result) {
    this.oCache[id] = result;
  },
  // id='acctype_openid/uin'
  get: function get(id) {
    return this.oCache[id] || {};
  }
}; // 用户信息userinfo管理

export var userInfoManager = {
  waitingQueue: {},
  userInfoCache: {},
  isWaiting: {},
  addToWaitingQueue: function addToWaitingQueue(_ref2) {
    var acctype = _ref2.acctype,
        openid = _ref2.openid,
        success = _ref2.success,
        fail = _ref2.fail,
        lang = _ref2.lang;
    var id = "".concat(acctype, "_").concat(openid);

    if (lang) {
      id += "_".concat(lang);
    }

    if (isArray(this.waitingQueue[id])) {
      this.waitingQueue[id].push({
        success: success,
        fail: fail
      });
    } else {
      this.waitingQueue[id] = [{
        success: success,
        fail: fail
      }];
    }
  },
  // //处理wx，qc，wg，pt各类获取用户信息的请求
  // getInfo({id,data,success,fail,filter}){
  // },
  // 微信登录用户信息
  getWXUserInfo: function getWXUserInfo(_ref3) {
    var openid = _ref3.openid,
        access_token = _ref3.access_token,
        lang = _ref3.lang,
        success = _ref3.success,
        fail = _ref3.fail;
    var acctype = 'wx';
    var id = "".concat('wx' + '_').concat(openid);
    var self = this;

    if (lang) {
      id += "_".concat(lang);
    }

    var result = this.userInfoCache[id];
    var api = getLoginInterFace({
      type: 'userinfo',
      acctype: 'wx'
    });
    var emojicss = 'https://ossweb-img.qq.com/images/js/milo/biz/widget/emoji/emoji.css';

    if (!document.getElementById('milo_emoji_css')) {
      loader.loadCSS(emojicss, function () {}, 'milo_emoji_css');
    }

    if (result) {
      // 有缓存,直接消费
      if (0 == result.iRet) {
        isFunction(success) && success(result.userInfo);
      } else {
        isFunction(fail) && fail(result);
      }
    } else {
      this.addToWaitingQueue({
        acctype: acctype,
        openid: openid,
        success: success,
        fail: fail,
        lang: lang
      });

      if (this.isWaiting[id]) {
        return;
      }

      this.isWaiting[id] = true;
      loginStatus.clearAME(function () {
        Request.ajax({
          url: api,
          dataType: 'jsonp',
          data: {
            openid: openid,
            access_token: access_token,
            lang: lang
          },
          success: function success(result) {
            self.isWaiting[id] = false; // 格式化返回数据：

            var data = result.data;
            var newResult = extend(result, {
              userInfo: data,
              formatUserInfo: {}
            });

            if (0 == result.iRet) {
              var city = data.city,
                  country = data.country,
                  province = data.province,
                  sex = data.sex; // sex:1男  2女  0未知

              var avatarUrl = data.headimgurl;

              if (avatarUrl) {
                avatarUrl = "".concat(data.headimgurl, "/0");
              }

              var nickName = data.nickname;
              newResult.formatUserInfo = {
                nickName: nickName,
                avatarUrl: avatarUrl,
                sex: sex,
                country: country,
                province: province,
                city: city
              };
            } // 逻辑返回要缓存


            self.userInfoCache[id] = newResult;
            self.run({
              acctype: acctype,
              openid: openid,
              lang: lang,
              result: newResult
            });
            ATM.reportATM({
              toappid: 1,
              tomoduletype: 32,
              tointer: 3,
              toreturncode: parseInt(result.iRet) === 0 ? 0 : 1,
              businesstype: getGameId(),
              result: result.iRet,
              serialnum: result.sLogSerialNum || '',
              cgi: location.href,
              errormsg: result.sMsg
            });
          },
          fail: function fail() {
            ATM.reportATM({
              toappid: 1,
              tomoduletype: 32,
              tointer: 3,
              toreturncode: 1,
              businesstype: getGameId(),
              result: -999,
              cgi: location.href,
              errormsg: '网络超时'
            });
            self.isWaiting[id] = false; // 服务器相关的报错，不缓存

            self.userInfoCache[id] = null;
            self.run({
              acctype: acctype,
              openid: openid,
              lang: lang,
              result: {
                iRet: 0,
                sMsg: '系统繁忙:'
              }
            });
          }
        });
      });
    }
  },
  // qc,wg,ks登录用户信息
  getUserInfoByOpenid: function getUserInfoByOpenid(_ref4) {
    var acctype = _ref4.acctype,
        openid = _ref4.openid,
        access_token = _ref4.access_token,
        appid = _ref4.appid,
        refresh_token = _ref4.refresh_token,
        success = _ref4.success,
        fail = _ref4.fail;
    var id = "".concat(acctype, "_").concat(openid);
    var self = this;
    var result = this.userInfoCache[id];
    var api = getLoginInterFace({
      type: 'checkLogin'
    });

    if (result) {
      // 有缓存,直接消费
      if (0 == result.iRet) {
        var userInfo = result.userInfo,
            formatUserInfo = result.formatUserInfo;
        isFunction(success) && success({
          userInfo: userInfo,
          formatUserInfo: formatUserInfo
        });
      } else {
        isFunction(fail) && fail(result);
      }
    } else {
      this.addToWaitingQueue({
        acctype: acctype,
        openid: openid,
        success: success,
        fail: fail
      });

      if (this.isWaiting[id]) {
        return;
      }

      this.isWaiting[id] = true;

      var doGetInfo = function doGetInfo(data) {
        self.isWaiting[id] = false; // 格式化返回数据：

        var newResult = extend({}, {
          userInfo: data,
          formatUserInfo: {}
        });

        if (0 == data.errorCode) {
          // eslint-disable-next-line prefer-const
          var city = data.city,
              country = data.country,
              province = data.province,
              sex = data.sex,
              nickName = data.nickName; // sex:1男  2女  0未知

          nickName = decodeURIComponent(nickName);
          var avatarUrl = data.face;
          newResult.formatUserInfo = {
            nickName: nickName,
            avatarUrl: avatarUrl,
            sex: sex,
            country: country,
            province: province,
            city: city
          };
          newResult.iRet = 0;
        } // 逻辑返回要缓存


        self.userInfoCache[id] = newResult;
        self.run({
          acctype: acctype,
          openid: openid,
          result: newResult
        });
      };

      var oCache = loginSvrCache.get(id);

      if (!oCache || !oCache.face) {
        loginStatus.clearAME(function () {
          Request.ajax({
            url: api,
            dataType: 'jsonp',
            data: {
              appid: appid,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token,
              acctype: acctype
            },
            success: function success(res) {
              doGetInfo(res);
            },
            fail: function fail(xhr, statusText) {
              self.isWaiting[id] = false; // 服务器相关的报错，不缓存

              self.userInfoCache[id] = null;
              self.run(acctype, openid, {
                iRet: 0,
                sMsg: "\u7CFB\u7EDF\u7E41\u5FD9:".concat(statusText)
              });
            }
          });
        });
      } else {
        doGetInfo(oCache);
      }
    }
  },
  getWegameUserInfo: function getWegameUserInfo(_ref5) {
    var openid = _ref5.openid,
        access_token = _ref5.access_token,
        appid = _ref5.appid,
        refresh_token = _ref5.refresh_token,
        lang = _ref5.lang,
        success = _ref5.success,
        fail = _ref5.fail;
    var acctype = 'wg';
    var id = "".concat(acctype, "_").concat(openid);
    var _id = id;

    if (lang) {
      id += "_".concat(lang);
    }

    var self = this;
    var result = this.userInfoCache[id];
    var api = getLoginInterFace({
      type: 'checkLogin'
    });

    if (result) {
      // 有缓存,直接消费
      if (0 == result.iRet) {
        var userInfo = result.userInfo,
            formatUserInfo = result.formatUserInfo;
        isFunction(success) && success({
          userInfo: userInfo,
          formatUserInfo: formatUserInfo
        });
      } else {
        isFunction(fail) && fail(result);
      }
    } else {
      this.addToWaitingQueue({
        acctype: acctype,
        openid: openid,
        success: success,
        fail: fail
      });

      if (this.isWaiting[id]) {
        return;
      }

      this.isWaiting[id] = true;

      var doGetInfo = function doGetInfo(data) {
        self.isWaiting[id] = false; // 格式化返回数据：

        var newResult = extend({}, {
          userInfo: data,
          formatUserInfo: {}
        });

        if (0 == data.errorCode) {
          // eslint-disable-next-line prefer-const
          var city = data.city,
              country = data.country,
              province = data.province,
              sex = data.sex,
              nickName = data.nickName; // sex:1男  2女  0未知

          nickName = decodeURIComponent(nickName);
          var avatarUrl = data.face;
          newResult.formatUserInfo = {
            nickName: nickName,
            avatarUrl: avatarUrl,
            sex: sex,
            country: country,
            province: province,
            city: city
          };
          newResult.iRet = 0;
        } // 逻辑返回要缓存


        self.userInfoCache[id] = newResult;
        self.run({
          acctype: acctype,
          openid: openid,
          result: newResult
        });
      };

      var oCache = loginSvrCache.get(_id);

      if (!oCache || !oCache.face) {
        loginStatus.clearAME(function () {
          Request.ajax({
            url: api,
            dataType: 'jsonp',
            data: {
              appid: appid,
              openid: openid,
              access_token: access_token,
              refresh_token: refresh_token,
              acctype: 'wg'
            },
            success: function success(res) {
              doGetInfo(res);
            },
            fail: function fail(xhr, statusText) {
              self.isWaiting[id] = false; // 服务器相关的报错，不缓存

              self.userInfoCache[id] = null;
              self.run(acctype, openid, lang, {
                iRet: 0,
                sMsg: "\u7CFB\u7EDF\u7E41\u5FD9:".concat(statusText)
              });
            }
          });
        });
      } else {
        doGetInfo(oCache);
      }
    }
  },
  // TODO: AMT上报
  getPtUserInfo: function getPtUserInfo(uin, success, fail) {
    var id = "pt_".concat(uin);
    var self = this;
    var result = self.userInfoCache[id]; // 有缓存

    if (result) {
      if (0 == result.iRet) {
        var _ref6 = result || {},
            userInfo = _ref6.userInfo,
            formatUserInfo = _ref6.formatUserInfo;

        isFunction(success) && success({
          userInfo: userInfo,
          formatUserInfo: formatUserInfo
        });
      } else {
        isFunction(fail) && fail(result);
      }
    } else {
      self.addToWaitingQueue({
        acctype: 'pt',
        openid: uin,
        success: success,
        fail: fail
      });

      if (self.isWaiting[id]) {
        return;
      }

      self.isWaiting[id] = true;
      var svrResult = loginSvrCache.get(id) || {};
      svrResult.nickName = decodeURIComponent(svrResult.nickName || '');
      var _userInfo = svrResult;
      var newResult = {
        iRet: 0,
        userInfo: _userInfo
      };
      var _formatUserInfo = {};

      var _ref7 = svrResult || {},
          userUin = _ref7.userUin,
          nickName = _ref7.nickName; // 获取头像


      var api = getLoginInterFace({
        type: 'avatar',
        acctype: 'pt',
        uin: userUin
      });
      window.pt = {
        setHeader: function setHeader(oFace) {
          self.isWaiting[id] = false;

          if (oFace && oFace[userUin]) {
            var avatarUrl = oFace[userUin];
            _formatUserInfo = {
              uin: uin,
              userUin: userUin,
              nickName: nickName,
              avatarUrl: avatarUrl
            };
            newResult.userInfo.avatarUrl = avatarUrl;
            newResult.formatUserInfo = _formatUserInfo;
          } // 逻辑返回要缓存


          self.userInfoCache[id] = newResult;
          self.run({
            acctype: 'pt',
            openid: uin,
            result: newResult
          });
        }
      };
      loader.loadScript(api, function () {});
    }
  },
  // 拿到数据，开始消费
  // result 格式：

  /* {
        iRet:0,
        sMsg:'OK',
        userInfo:{xxx}
    }*/
  run: function run(_ref8) {
    var acctype = _ref8.acctype,
        openid = _ref8.openid,
        lang = _ref8.lang,
        result = _ref8.result;
    var id = "".concat(acctype, "_").concat(openid);

    if (lang) {
      id += "_".concat(lang);
    }

    var cbArr = this.waitingQueue[id];

    while (cbArr && cbArr.length) {
      var cb = cbArr.shift();

      if (0 == result.iRet) {
        var userInfo = result.userInfo,
            formatUserInfo = result.formatUserInfo;
        isFunction(cb.success) && cb.success({
          userInfo: userInfo,
          formatUserInfo: formatUserInfo
        });
      } else {
        isFunction(cb.fail) && cb.fail(result);
      }
    }

    this.isWaiting[id] = false;
  }
};
/**
 * 获取wegame一键登录授权url
 * @param {*} loginParams wegame一键登录Url参数
 */

export var getWgAuthUrl = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(loginParams) {
    var clientId, railGameId, redirectUri, ticket, userId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            clientId = loginParams.clientId, railGameId = loginParams.railGameId, redirectUri = loginParams.redirectUri, ticket = loginParams.ticket, userId = loginParams.userId;
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              Request.ajax({
                url: 'https://ams.game.qq.com/ams/userLoginSvr',
                type: 'GET',
                dataType: 'jsonp',
                data: {
                  a: 'wgauth',
                  login_account_type: 0,
                  user_id: userId,
                  // QQ号
                  ticket: ticket,
                  // skey
                  client_id: clientId,
                  game_id: railGameId,
                  target_url: redirectUri
                },
                success: function success(retObj) {
                  if (retObj && retObj.result == 0 && retObj.authorized_url) {
                    resolve(retObj.authorized_url);
                  } else {
                    reject();
                  }
                },
                error: function error() {
                  reject();
                }
              });
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getWgAuthUrl(_x) {
    return _ref9.apply(this, arguments);
  };
}();